import React, { Component } from 'react';
import './Header.css';

class Header extends Component {
  render() {
    return (
      <div className={"Header-layout"}>
        <h2 className={"Header-title"}>
          react-mm-text demo
        </h2>
      </div>
    );
  }
}

export default Header;
